import { render, staticRenderFns } from "./transfer-dialog.vue?vue&type=template&id=497e6254&scoped=true&"
import script from "./transfer-dialog.vue?vue&type=script&lang=js&"
export * from "./transfer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./transfer-dialog.vue?vue&type=style&index=0&id=497e6254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e6254",
  null
  
)

export default component.exports